import planRequest from './request';
import { Observable } from 'rxjs';

const planObservable = new Observable((subscriber) => {
  subscriber.next([]);
  planRequest()
    .then((plans) => {
      subscriber.next(plans);
      subscriber.complete();
    })
    .catch(() => {
      subscriber.error();
    });
});

export default planObservable;
